import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ErrorService } from './error.service';
var ErrorComponent = /** @class */ (function () {
    function ErrorComponent(errorService, route) {
        this.errorService = errorService;
        this.route = route;
    }
    ErrorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.paramMap.pipe(switchMap(function (params) {
            var idError = params.get('idError');
            return of(idError);
        })).subscribe(function (idError) {
            _this.errorMessageById(idError);
        });
    };
    ErrorComponent.prototype.errorMessageById = function (idMessage) {
        var _this = this;
        this.errorService.getErrorMessage().subscribe(function (messages) {
            if (messages && messages.errorMessages.length > 0)
                _this.errorMessage = messages.errorMessages.filter(function (message) { return message.idErrorMessage.toString().includes(idMessage); })[0];
        });
    };
    Object.defineProperty(ErrorComponent.prototype, "errorMessageDescription", {
        get: function () {
            if (this.errorMessage)
                return this.errorMessage.message;
            else
                return "A ação não pode ser completada. Tente novamente em alguns segundos. \n Se o problema persistir, contate seu canal de atendimento.";
        },
        enumerable: true,
        configurable: true
    });
    return ErrorComponent;
}());
export { ErrorComponent };
